'use strict';

var _ = require('lodash');
var React = require('react');

var getValueLinkProps = function getValueLinkProps(props) {
    return _.has(props, 'valueLink') ? {
        value: props.valueLink.value,
        onChange: props.valueLink.requestChange
    } : {};
};

var createWithUtils = function createWithUtils(innerComp) {
    return function (props) {
        //eslint-disable-line react/display-name
        var getClassName = function getClassName(defaultClassName) {
            var propName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'className';
            return [defaultClassName, props[propName]].join(' ');
        };
        var valueLinkProps = getValueLinkProps(props);
        var newProps = _({}).assign(props, { getClassName: getClassName }, valueLinkProps).omit(['valueLink']).value();

        return React.createElement(innerComp, newProps);
    };
};

createWithUtils.propTypes = {
    automationId: React.PropTypes.string
};

createWithUtils.defaultProps = {
    automationId: null
};

module.exports = createWithUtils;


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/hoc/withUtils.js